import * as Yup from "yup";

const getMaxLengthMessage = (fieldName, maxLength) => `${fieldName} can't be longer than ${maxLength} symbols`;
const getRequiredMessage = (fieldName) => `Please enter ${fieldName}`;

export default Yup.object({
  contactFirstName: Yup.string()
    .max(20, ({ max }) => getMaxLengthMessage("Contact First Name", max))
    .required(getRequiredMessage("Contact First Name")),
  contactLastName: Yup.string()
    .max(20, ({ max }) => getMaxLengthMessage("Contact Last Name", max))
    .required(getRequiredMessage("Contact Last Name")),
  contactEmail: Yup.string()
    .email("Invalid email format")
    .max(50, ({ max }) => getMaxLengthMessage("Contact Email", max))
    .required(getRequiredMessage("Contact Email")),
  contactPhone: Yup.string()
    .max(20, ({ max }) => getMaxLengthMessage("Contact Phone Number", max))
    .required(getRequiredMessage("Contact Phone")),
  company: Yup.string()
    .max(100, ({ max }) => getMaxLengthMessage("Company", max))
    .required(getRequiredMessage("Company")),
  name: Yup.string()
    .max(100, ({ max }) => getMaxLengthMessage("Job Name", max))
    .required(getRequiredMessage("Job Name")),
  geometry: Yup.array().required("Please specify at least one area"),
  machines: Yup.array().min(1, "At least one machine is required").required("At least one machine is required"),
});
